import * as React from 'react';
import styled from 'styled-components';
import {HashLink} from 'react-router-hash-link';
import HomeImage from './../../assets/parental_menu_home.png';
import ActivitiesImage from './../../assets/parental_menu_activities.png';
import WatchImage from './../../assets/parental_menu_watch.png';
import BackgroundImage from '../../assets/parental_bg.png';
import {debugCNitoUrl} from '../../helpers';
import {useTranslation} from 'react-i18next';
import {getCurrentLang} from '../../utils/i18n';
import {mobileMediaQuery, useIsWeb} from '../../styles';
import {ParentalTitleView} from '../CartoonitoParentalHeader';

const ParentalMenu = () => {
    const {t} = useTranslation();
    const isWeb = useIsWeb();

    return (
        <Container>
            {!isWeb && <ParentalTitleView />}
            <HStack>
                <MenuButton
                    text={t('parentalPage.welcome.title')}
                    image={HomeImage}
                    link="welcome"
                />
                <MenuButton
                    text={t('parentalPage.activities.title')}
                    image={ActivitiesImage}
                    link="activities"
                />
                <MenuButton
                    text={t('parentalPage.waysToWatch.title')}
                    image={WatchImage}
                    link="waystowatch"
                />
            </HStack>
        </Container>
    );
};

const Container = styled.div`
    position: fixed;
    display: flex;
    flex-direction: column;
    padding: 20px 0px;
    background-image: url(${BackgroundImage});
    background-repeat: repeat-x;
    width: 100%;
    justify-content: center;
    z-index: 101;
    background-color: white;
`;

const HStack = styled.div`
    flex-direction: row;
    display: flex;
    align-items: center;
    align-self: center;

    max-width: 1440px;
    height: 20px;
`;

const MenuButton = props => {
    const link = getCurrentLang() === 'es' ? '/padres' : '/pais';

    return (
        <WrappedLink to={`${link}${debugCNitoUrl()}#${props.link}`}>
            <MenuImage src={props.image} />
            <MenuText>{props.text}</MenuText>
        </WrappedLink>
    );
};

const MenuImage = styled.img`
    align-self: center;

    ${mobileMediaQuery} {
        width: 14px;
    }
`;

const MenuText = styled.div`
    color: black;
    font-size: 18px;
    font-family: 'Rodger';
    font-weight: 700;
    padding-left: 16px;

    text-transform: uppercase;

    ${mobileMediaQuery} {
        font-size: 14px;
        padding-left: 6px;
    }
`;

const WrappedLink = styled(HashLink)`
    display: flex;
    flex-direction: row;
    color: transparent;
    justify-content: center;
    align-items: center;
    padding-right: 48px;

    :last-child {
        padding-right: 0px;
    }

    ${mobileMediaQuery} {
        padding-right: 12px;
    }
`;

export default ParentalMenu;
